<template>
  <div class="flex justify-between md:block w-full">
    <h1 class="text-2xl">داشبورد</h1>
    <h3 class="text-muted mt-2">{{ $store.state.user.name }} - {{ $store.state.user.role.name }}</h3>
  </div>
  <hr class="border border-dark-line my-4 md:my-8">

  <VPanel class="relative md:p-6">
    <div class="md:flex md:justify-between mb-6">
      <h1 class="text-lg md:text-xl">سفارشات خدمات</h1>
      <div class="flex mt-2 md:mt-0">
        <VInput type="number" placeholder="شماره اتاق ..." class="ml-4" v-model="filter.roomNumber"/>
        <select class="w-full rounded-lg bg-dark-form" v-model="filter.status">
          <option value="">همه</option>
          <option value="pending">در انتظار</option>
          <option value="seen">دیده شده</option>
          <option value="delivered">تحویل شده</option>
        </select>
      </div>
    </div>

    <div class="grid md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-5"
         v-if="serviceRequests.length > 0">

      <ServiceRequestCard
          v-for="(request, index) in serviceRequests"
          :key="request.id"
          :service-request="request"
          @updated="serviceRequests[index] = $event"
          @roomNumber="filter.roomNumber = $event"/>

    </div>

    <div v-else>
      <h1 class="text-center text-lg my-10">موردی یافت نشد.</h1>
    </div>

    <VLoadingScreen :show="loading"/>

  </VPanel>

</template>

<script>
// @ is an alias to /src

import VPanel from "@/components/VPanel";
import {getServiceRequests} from "@/API/API";
import ServiceRequestCard from "@/components/ServiceRequestCard";
import VInput from "@/components/General/VInput";
import VLoadingScreen from "@/components/General/VLoadingScreen";
import {mapState} from "vuex";

export default {
  name: 'HomeView',
  components: {VLoadingScreen, VInput, ServiceRequestCard, VPanel},
  data() {
    return {
      serviceRequests: [],
      loading: true,
      filter: {
        roomNumber: '',
        status: ''
      },
    }
  },
  computed: {
    ...mapState(['fcmMessage'])
  },
  async created() {
    this.serviceRequests = (await getServiceRequests()).data
    this.loading = false
  },
  watch: {
    'fcmMessage'(fcmMessage) {
      if (fcmMessage.data.serviceRequest) {
        this.serviceRequests.unshift(JSON.parse(fcmMessage.data.serviceRequest))
      }
    },
    async 'filter.roomNumber'() {
      this.loading = true
      this.serviceRequests = (await getServiceRequests(this.filter.roomNumber, this.filter.status)).data
      this.loading = false
    },
    async 'filter.status'() {
      this.loading = true
      this.serviceRequests = (await getServiceRequests(this.filter.roomNumber, this.filter.status)).data
      this.loading = false
    }
  }
}
</script>
